/* --------------------------- Define Constants ----------------------------- */
export const TEMPLATE = 'TEMPLATE'

/* ------------------------------- Actions ---------------------------------- */
/*--- Template Action ---*/
export const templateAction = () => ({
  type: TEMPLATE
})




// WEBPACK FOOTER //
// ./src/interface/store/departments/template/actions.js